var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:['base-button', _vm.styleButton, _vm.size],attrs:{"disabled":_vm.isDisebled}},[(_vm.iconVisible)?_c('i',{staticClass:"pi pi-google",staticStyle:{"color":"red"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }